import { render, staticRenderFns } from "./BankBranchTable.vue?vue&type=template&id=35113f96&scoped=true&"
import script from "./BankBranchTable.vue?vue&type=script&lang=js&"
export * from "./BankBranchTable.vue?vue&type=script&lang=js&"
import style0 from "./BankBranchTable.vue?vue&type=style&index=0&id=35113f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35113f96",
  null
  
)

component.options.__file = "BankBranchTable.vue"
export default component.exports